import {Pipe, PipeTransform} from '@angular/core';
import {BulkEditChangeTypeEnum} from '../../model/bulk-edit-change-type.enum';
import {BulkEditSession} from '../../model/bulk-edit-session';

@Pipe({
  name: 'relevantBulkEditChangesFilter'
})
export class RelevantBulkEditChangesFilterPipe implements PipeTransform {

  public static filter(changeTypes: Array<BulkEditChangeTypeEnum>, bes: BulkEditSession, includeEmpty = false): Array<BulkEditChangeTypeEnum> {
    return new RelevantBulkEditChangesFilterPipe().transform(changeTypes, bes, includeEmpty);
  }

  transform(changeTypes: Array<BulkEditChangeTypeEnum>, bes: BulkEditSession, includeEmpty = false): Array<BulkEditChangeTypeEnum> {
    if (!changeTypes || !bes || bes.error || !bes.changes) {
      return changeTypes;
    }
    return changeTypes.filter(ct => ct !== BulkEditChangeTypeEnum.UNCHANGED &&
      (includeEmpty ||
        (!includeEmpty && bes.changes.get(ct).length > 0)));
  }
}
